module.exports = __webpack_public_path__ + "img/attach.e6bcdc7b.svg";